const constants = {
  SKIP_LINK_ID: 'main-content',
};

export default constants;
